import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-beige" data-id="element-42" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-content px-6 py-20" data-id="element-43" data-mp="1gdgzbbjl6g1o">
        <h2 className="text-center font-display text-[24px] font-bold leading-tight text-ink sm:text-[27px]" data-id="element-44" data-mp="1gausxf8fm6l1">
          Najczęściej zadawane pytania
        </h2>

        <ul className="mx-auto mt-8 max-w-lg space-y-2.5" data-id="element-45" data-mp="292o4uuhgk5wf">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-lg border border-ink/10 bg-white" data-id="element-46" data-mp="1z3p03mztcuep" data-mpi={index}>
                <h3 data-id="element-47" data-mp="sl0guzvxsm1u">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left text-[11px] font-semibold text-ink transition-colors duration-150 ease-out hover:text-coral" data-id="element-48" data-mp="no0ccteqjrcu">
                    {faq.question}
                    <PlusIcon className={`h-3.5 w-3.5 shrink-0 text-coral transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-49" data-mp="ki1yho3pogfx" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-50" data-mp="3t07so3wrpg48">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-51" data-mp="1tesn3dpnn1a">
                      <p className="px-4 pb-4 text-[11px] leading-relaxed text-muted" data-id="element-52" data-mp="1ppuq4s78xvol">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}